import React from 'react';
import './ConfirmationModal.css';
import successIcon from '../../assets/images/icon-success.png';
import failureIcon from '../../assets/images/icon-failure.png';
import closeIcon from '../../assets/images/icon-close.png';
import FormButton from '../FormComponents/FormButton/FormButton';

const ConfirmationModal = ({ handleClose }) => {
  let message = 'Your mail has been successfully sent. DGV will contact you shortly';
  return (
    <div className="modal-background">
      <div className="confirmation-modal-container">
        <div className="header-container">
          <img className="close-icon" src={closeIcon} onClick={handleClose} alt="" />
          <img className="status-icon" src={successIcon} alt="" />
        </div>
        <div className="modal-container">
          <p>{message}</p>
          <FormButton title={'Close'} handleSubmit={handleClose} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
